/**
 * Shared link/text rendering constants used across components.
 * Centralised here to avoid duplication between WelcomePage, WhatYouShouldKnow, FinancialAidText, etc.
 */

/** Tailwind classes applied to all inline hyperlinks rendered from rich text. */
export const INLINE_LINK_CLASS =
  "text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 underline";

/** Canonical FAFSA application URL (studentaid.gov). */
export const FAFSA_URL = "https://studentaid.gov/h/apply-for-aid/fafsa";
